// Signal-group catalogue (severity-threshold-strategy §3.1). Reports tag each
// incident/anomaly with a groupId (G1–G11); we map it to a label + what it
// indicates, for compact chips and tooltips in the analytics UI.
const GROUPS = {
  G1: { name: 'Loss & recovery', indicates: 'Network losing packets; protocol recovering (retransmits/ARQ/FEC working)', class: 'stress' },
  G2: { name: 'Congestion / backpressure', indicates: 'Queuing building; drops imminent if it continues', class: 'stress' },
  G3: { name: 'Latency / timing', indicates: 'Path slowing; recovery window shrinking', class: 'stress' },
  G4: { name: 'Throughput', indicates: 'Stream not fitting the pipe', class: 'stress' },
  G5: { name: 'Transport impact', indicates: 'Content actually lost or undecodable on the wire', class: 'impact' },
  G6: { name: 'Connectivity', indicates: 'No signal / session loss', class: 'impact' },
  G7: { name: 'Input integrity (decode)', indicates: "What arrived isn't continuously decodable", class: 'impact' },
  G8: { name: 'Encode health', indicates: 'Encoder not keeping up with realtime', class: 'impact' },
  G9: { name: 'Redundancy / failover', indicates: 'Protection state consumed or degraded', class: 'stress' },
  G10: { name: 'Output delivery', indicates: 'Downstream handoff failing', class: 'impact' },
  G11: { name: 'Compliance / ancillary', indicates: 'Timecode, loudness, captions — contractual, not picture', class: 'context' },
};

// Ordered G1–G11 catalogue for the legend (info popover). Object key insertion
// order is preserved, so this stays G1 → G11.
export function signalGroupList() {
  return Object.entries(GROUPS).map(([id, group]) => ({ id, ...group }));
}

// Resolve a groupId (+ optional groupName fallback from the report) to display
// metadata. Returns id: null when there's no group to show.
export function signalGroupMeta(groupId, groupName) {
  const id = (groupId || '').toString().trim().toUpperCase();
  const known = GROUPS[id];
  if (!id && !groupName) return { id: null, name: '', indicates: '', class: '' };
  return {
    id: id || null,
    name: (known && known.name) || groupName || '',
    indicates: (known && known.indicates) || '',
    class: (known && known.class) || '',
  };
}

// One-line tooltip text for a group, e.g. "G3 Latency / timing — Path slowing… (stress)".
export function signalGroupTooltip(groupId, groupName) {
  const meta = signalGroupMeta(groupId, groupName);
  if (!meta.id && !meta.name) return '';
  const head = [meta.id, meta.name].filter(Boolean).join(' ');
  const tail = meta.class ? ` (${meta.class})` : '';
  return meta.indicates ? `${head} — ${meta.indicates}${tail}` : `${head}${tail}`;
}

export default signalGroupMeta;
